var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "viewport",
          rawName: "v-viewport",
          value: _vm.onViewportIntersection,
          expression: "onViewportIntersection",
        },
      ],
      staticClass: "rb-lazy__icon--container",
      on: {
        click: function (e) {
          return _vm.$emit("onClick", e)
        },
      },
    },
    [
      !_vm.isVisible
        ? _c("div", { staticClass: "common__icon rb-lazy__icon--skeleton" })
        : _c(
            "span",
            {
              ref: "lazy-icon",
              staticClass: "rb-lazy-icon common__icon",
              class:
                ((_obj = {}),
                (_obj["common__icon--" + _vm.icon] = _vm.isVisible),
                _obj),
            },
            [_vm._v(_vm._s(_vm.text))]
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }